import { Collection } from 'modules/core/lib/mobx-rest'

import Compensation from 'modules/contracts/store/models/Compensation'

export class Compensations extends Collection<Compensation> {
  get cacheKey(): string {
    return 'compensations'
  }

  get indexes() {
    return ['contract_version_id']
  }

  async batchFetchByIds(ids: string[], sliceSize: number) {
    ids = Array.from(new Set(ids)) // removes duplicate ids

    const batches = []
    this.reset([]) // clear the existing collection
    for (let i = 0; i < ids.length; i += sliceSize) {
      const slicedIds: string[] = ids.slice(i, i + sliceSize)

      batches.push(
        this.fetch({
          data: {
            ids: slicedIds,
          },
          remove: false,
        })
      )
    }

    await Promise.all(batches)
  }

  model() {
    return Compensation
  }
}

export default new Compensations()
